import { render } from "./instalacion.vue?vue&type=template&id=5aefef42&scoped=true"
import script from "./instalacion.vue?vue&type=script&lang=js"
export * from "./instalacion.vue?vue&type=script&lang=js"

import "./instalacion.vue?vue&type=style&index=0&id=5aefef42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aefef42"]])

export default __exports__